import { IApplicationState } from '../../types/redux';
import { getUser } from './getUser';

export const getUserPhone = (state: IApplicationState) => {
  const user = getUser(state);

  const phone = user?.phone;

  return phone || null;
};
